import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';

export const ProspectsStepper = ({ activeStep, steps }) => {
    return (
        <Stepper activeStep={activeStep} sx={{ marginBottom: 4 }}>
            {steps.map((label, index) => (
                <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};
